import React, { Fragment } from 'react';
import ScrollableList from '../ScrollableList';
import SmallSpinner from '../SmallSpinner/SmallSpinner';
import ListHeader from './ListHeader/ListHeader';
import styles from './ParticipantsList.module.scss';
import ParticipantListItem from '../ParticipantListItem';

/**
 * Renders a list of participants with their respective details and presence status.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.className=''] - The CSS class name for the component.
 * @param {string} props.eventId - The ID of the event.
 * @param {Array} props.list - The list of participant sections.
 * @param {boolean} [props.busy=false] - Indicates if the component is in a busy state.
 * @param {Function} [props.routePrefixFn] - A function to generate the route prefix based on the section and participant.
 * @param {string} [props.routePrefix='.'] - The default route prefix for the participants.
 * @return {JSX.Element} The rendered ParticipantsList component.
 */
function ParticipantsList(props) {
    const { className = '', eventId, list, busy = false, routePrefixFn, routePrefix = '.' } = props;

    return (
        <div className={styles.ParticipantsList}>
            <SmallSpinner visible={busy} />
            <div>
                <ScrollableList className={className} savePosition={`eventParticipants-${eventId}`}>
                    {list.map((section, index) => (
                        <Fragment key={index}>
                            <ListHeader>{section.title}</ListHeader>
                            {section.items.map((participant, i) => {
                                const prefix = routePrefixFn ? routePrefixFn(section, participant) : routePrefix;
                                return (
                                    <ParticipantListItem
                                        key={i}
                                        tagName="div"
                                        participant={participant}
                                        href={[prefix, participant.user_id || '-', participant.participant_id || '-'].join('/')}
                                        showUserDetails
                                        showPresence
                                        large
                                    />
                                );
                            })}
                        </Fragment>
                    ))}
                </ScrollableList>
            </div>
        </div>
    );
}

export default ParticipantsList;
